<div class="app_guide_wrap" *ngIf="!isScorm">
  <div id="guide_tools{{step}}" class="guide_icon" *ngIf="isShowItem && step === 0" (click)="clickMenu()"></div>
  <div id="guide_tools{{step}}" class="guide_tools" [ngClass]="{'enter':step === 1,'haveNotExerciseBook':!haveExerciseBook}" *ngIf="isShowItem && step === 1" (click)="goTools()"></div>
  <div id="guide_hand_text" class="guide_hand_text">
    <div class="guide_hand hand{{step}} {{haveExerciseBook}}"  *ngIf="isShowItem"></div>
    <p class="guide_txt step{{step}}-txt {{haveExerciseBook}}"  *ngIf="isShowItem">
      <span *ngIf="step === 0">「 应用工具 」新功能上线，快点这里查看！</span>
      <span *ngIf="step === 1" >进入体验在线管理工具吧！</span>
    </p>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-guide/app-guide.component.html